export const dossierCategoryFields = [{
        name: "description",
        title: "Descrizione"
    }];
